import React from 'react';
import PropTypes from 'prop-types';
import { ThreeDimensionalIcon, PlayIcon } from '@domain-group/fe-co-icon';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import { getImageUrl, ListingImageSizes } from '@domain-group/fe-allhomes-library';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import * as styles from './property-walkthrough.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Thumbnail = _ref => {
  var url = _ref.url,
    label = _ref.label,
    icon = _ref.icon,
    onClick = _ref.onClick;
  return ___EmotionJSX("div", {
    css: styles.thumbnail,
    style: {
      backgroundImage: "url(".concat(getImageUrl(url, ListingImageSizes.MEDIUM), ")")
    }
  }, ___EmotionJSX(Button, {
    onClick: onClick,
    css: styles.thumbnailButton,
    appearance: "transparent",
    size: "responsive",
    icon: icon
  }, label));
};
Thumbnail.propTypes = {
  url: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired
};
export var PropertyWalkthrough = _ref2 => {
  var video = _ref2.video,
    virtualTour = _ref2.virtualTour,
    onVideoClick = _ref2.onVideoClick,
    onVirtualTourClick = _ref2.onVirtualTourClick,
    title = _ref2.title;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var handleVideoClick = () => {
    sendEvent('video-click');
    onVideoClick();
  };
  var handleVirtualTourClick = () => {
    sendEvent('virtual-tour-click');
    onVirtualTourClick();
  };
  return ___EmotionJSX("div", {
    css: styles.walkthrough
  }, ___EmotionJSX("div", {
    css: styles.heading
  }, title), ___EmotionJSX("div", {
    css: styles.thumbnails
  }, video && ___EmotionJSX(Thumbnail, {
    label: "Video",
    icon: ___EmotionJSX(PlayIcon, null),
    url: video,
    onClick: handleVideoClick
  }), virtualTour && ___EmotionJSX(Thumbnail, {
    label: "3D",
    icon: ___EmotionJSX(ThreeDimensionalIcon, null),
    url: virtualTour,
    onClick: handleVirtualTourClick
  })));
};
PropertyWalkthrough.propTypes = {
  video: PropTypes.string,
  virtualTour: PropTypes.string,
  onVideoClick: PropTypes.func,
  onVirtualTourClick: PropTypes.func,
  title: PropTypes.string
};
PropertyWalkthrough.defaultProps = {
  video: null,
  virtualTour: null,
  onVideoClick: () => {},
  onVirtualTourClick: () => {},
  title: 'Property walkthrough'
};